var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 13.3333H2.66732C1.95433 13.3546 1.35826 12.7955 1.33398 12.0826V3.91663C1.35826 3.20383 1.95444 2.64491 2.66732 2.66663H13.334C14.0469 2.64491 14.643 3.20383 14.6673 3.91663V12.0833C14.6427 12.7959 14.0467 13.3546 13.334 13.3333ZM2.66732 3.99996V11.9926L13.334 12V4.00729L2.66732 3.99996ZM8.95398 10.6666H4.00065C4.04967 10.1147 4.31088 9.60324 4.72932 9.23996C5.1952 8.77777 5.82119 8.51277 6.47732 8.49996C7.13344 8.51277 7.75943 8.77777 8.22532 9.23996C8.64365 9.60333 8.90483 10.1147 8.95398 10.6666ZM12.0007 9.99996H10.0007V8.66663H12.0007V9.99996ZM6.47732 7.99996C6.12003 8.01238 5.77363 7.87589 5.52084 7.6231C5.26805 7.37031 5.13157 7.02391 5.14398 6.66663C5.13177 6.3094 5.26832 5.96312 5.52106 5.71037C5.77381 5.45763 6.12009 5.32108 6.47732 5.33329C6.83455 5.32108 7.18083 5.45763 7.43357 5.71037C7.68632 5.96312 7.82287 6.3094 7.81065 6.66663C7.82307 7.02391 7.68658 7.37031 7.43379 7.6231C7.181 7.87589 6.8346 8.01238 6.47732 7.99996ZM12.0007 7.33329H9.33398V5.99996H12.0007V7.33329Z",
    fill: "#475A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdIcon);
export default __webpack_public_path__ + "static/media/id-icon.a49be11c57ce1fd7378cc38b8c366632.svg";
export { ForwardRef as ReactComponent };